<template>
    <div class="ma-5">
        <v-data-table
                :headers="headers"
                :items="desserts"
                :height="320"
                :fixed-header="true"
                :search="search"
                class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Grupo Filial</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field class="mr-10"
                                  v-model="search"
                                  append-icon="mdi-magnify"
                                  label="Pesquisar"
                                  single-line
                                  hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-autocomplete
                                                v-model="editedItem.id_grupo"
                                                :items="selects.grupos.items"
                                                label="Escolha o Grupo*"
                                                autofocus
                                                clearable
                                                outlined
                                                height="10"
                                                chips
                                                color="#042333"
                                                item-text="descricao"
                                                item-value="id"
                                                :error-messages="descricaoErrors"
                                                @input="$v.editedItem.id_grupo.$touch()"
                                                @blur="$v.editedItem.id_grupo.$touch()"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="12">
                                            <v-autocomplete
                                                v-model="editedItem.filial"
                                                :items="selects.filias.items"
                                                label="Escolha a Filial*"
                                                clearable
                                                outlined
                                                chips
                                                height="10"
                                                color="#042333"
                                                item-text="filial"
                                                item-value="filial"
                                                :error-messages="filialErrors"
                                                @input="$v.editedItem.filial.$touch()"
                                                @blur="$v.editedItem.filial.$touch()"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.filial_cd"
                                                :items="selects.filial_cd.items"
                                                label="Filial CD*"
                                                item-text="value"
                                                item-value="id"
                                                height="10"
                                                outlined
                                                chips
                                                style="margin-left: 5px"
                                                :error-messages="filialCdErrors"
                                                @input="$v.editedItem.filial_cd.$touch()"
                                                @blur="$v.editedItem.filial_cd.$touch()"
                                            ></v-select>
                                        </v-col>
                                         <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.matriz"
                                                :items="selects.matriz.items"
                                                chips
                                                label="Matriz*"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                :error-messages="matrizErrors"
                                                @input="$v.editedItem.matriz.$touch()"
                                                @blur="$v.editedItem.matriz.$touch()"
                                            ></v-select>
                                        </v-col>
                                         <v-col class="pa-0" cols="6" xs="6">
                                            <v-select
                                                v-model="editedItem.filtro_disponibilidade_drp"
                                                :items="selects.filtro_disponibilidade_drp.items"
                                                chips
                                                label="Filtro Disponibilidade DRP*"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                style="margin-left: 5px"
                                                :error-messages="filtroDisponibilidadeDrpErrors"
                                                @input="$v.editedItem.filtro_disponibilidade_drp.$touch()"
                                                @blur="$v.editedItem.filtro_disponibilidade_drp.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.cobertura_drp"
                                                label="Cobertura DRP*"
                                                style="margin-left: 5px"
                                                type="number"
                                                :error-messages="coberturaDrpErrors"
                                                @input="$v.editedItem.cobertura_drp.$touch()"
                                                @blur="$v.editedItem.cobertura_drp.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col class="pa-0" cols="6" xs="6">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.tempo_ressuprimento_drp"
                                                label="Tempo Ressuprimento DRP*"
                                                style="margin-left: 5px"
                                                type="number"
                                                :error-messages="tempoRessuprimentoDrpErrors"
                                                @input="$v.editedItem.tempo_ressuprimento_drp.$touch()"
                                                @blur="$v.editedItem.tempo_ressuprimento_drp.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:item.src_modulo="{ item }">
                <v-icon>{{item.src_modulo}}</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                        title="Editar Módulo"
                        class="mr-2"
                        @click="editItem(item)"
                >
                mdi-pencil
                </v-icon>
                <v-icon
                        title="Remover Módulo"
                        @click="deleteItem(item)"
                >
                mdi-delete
                </v-icon>
            </template>

        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import Api from "./../../api/cfg";

    export default {

        props: ['atualizarGrupoFilial'],

        data: () => ({
            dialog: false,
            search: '',
            headers: [
                {
                    text: 'ID',
                    value: 'id_grupo',
                },
                {
                    text: 'ID Filial',
                    value: 'filial',
                },
                {
                    text: 'Grupo',
                    align: 'left',
                    value: 'descricao',
                },

                {
                    text: 'Filial',
                    value: 'filial',
                },
                {
                    text: 'Matriz',
                    value: 'matriz',
                },
                {
                    text: 'CD',
                    value: 'filial_cd',
                },
                {
                    text: 'Cobertura DRP',
                    value: 'cobertura_drp',
                },
                {
                    text: 'Tempo Ressuprimento DRP',
                    value: 'tempo_ressuprimento_drp',
                },
                {
                    text: 'Filtro Disponibilidade DRP',
                    value: 'filtro_disponibilidade_drp',
                },
                {
                    text: 'Data de Cadastro',
                    align: 'left',
                    value: 'data_cadastro',
                },
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                id_grupo: '',
                filial: '',
                matriz: '',
                cobertura_drp: '',
                tempo_ressuprimento_drp: '',
                filtro_disponibilidade_drp: '',
                filial_cd: '',
            },
            defaultItem: {
                id_grupo: '',
                filial: '',
                matriz: '',
                cobertura_drp: '',
                tempo_ressuprimento_drp: '',
                filtro_disponibilidade_drp: '',
                filial_cd: '',
            },
            selects: {
                grupos: {
                    items: [],
                },
                filias: {
                    items: [],
                },
                matriz: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                },
                filtro_disponibilidade_drp: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                },
                filial_cd: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                }
            }
        }),

        validations: {
            editedItem: {
                id_grupo: {
                    required,
                },
                filial: {
                    required,
                },
                matriz: {
                    required,
                },
                cobertura_drp: {
                    required,
                },
                tempo_ressuprimento_drp: {
                    required,
                },
                filtro_disponibilidade_drp: {
                    required,
                },
                filial_cd: {
                    required
                }
            }
        },
        
        computed: {
            descricaoErrors() {
                const errors = []
                if (!this.$v.editedItem.id_grupo.$dirty) return errors
                !this.$v.editedItem.id_grupo.required && errors.push('Campo Obrigatório.')
                return errors
            },
            filialErrors() {
                const errors = []
                if (!this.$v.editedItem.filial.$dirty) return errors
                !this.$v.editedItem.filial.required && errors.push('Campo Obrigatório.')
                return errors
            },
            matrizErrors() {
                const errors = []
                if (!this.$v.editedItem.matriz.$dirty) return errors
                !this.$v.editedItem.matriz.required && errors.push('Campo Obrigatório.')
                return errors
            },
            coberturaDrpErrors() {
                const errors = []
                if (!this.$v.editedItem.cobertura_drp.$dirty) return errors
                !this.$v.editedItem.cobertura_drp.required && errors.push('Campo Obrigatório.')
                return errors
            },
            tempoRessuprimentoDrpErrors() {
                const errors = []
                if (!this.$v.editedItem.tempo_ressuprimento_drp.$dirty) return errors
                !this.$v.editedItem.tempo_ressuprimento_drp.required && errors.push('Campo Obrigatório.')
                return errors
            },
            filtroDisponibilidadeDrpErrors() {
                const errors = []
                if (!this.$v.editedItem.filtro_disponibilidade_drp.$dirty) return errors
                !this.$v.editedItem.filtro_disponibilidade_drp.required && errors.push('Campo Obrigatório.')
                return errors
            },
            filialCdErrors() {
                const errors = []
                if (!this.$v.editedItem.filial_cd.$dirty) return errors
                !this.$v.editedItem.filial_cd.required && errors.push('Campo Obrigatório.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Nova Filial' : 'Editar Filial'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },

            atualizarGrupoFilial(){
                this.initialize()
            }
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                Api.getGrupoFilial(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.grupoFilial;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })


                Api.getGrupos(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.grupos.items = response.data.grupos;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                Api.getFilial(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.filias.items = response.data.filias;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            
            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover o Grupo?')) {
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.delGrupoFilial(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }

                this.close()

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {
                    
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.addGrupoFilial(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>